import { useMemo } from "react";

import { useIntl } from "react-intl";

import { PinnedFieldsVisibility } from "@mapmycustomers/shared";
import RoleEnum from "@mapmycustomers/shared/enum/Role";
import Visibility from "@mapmycustomers/shared/enum/Visibility";

import getVisibilityDisplayName from "./getVisibilityDisplayName";

export const ALL_VISIBILITIES: PinnedFieldsVisibility[] = [
  Visibility.SHARED_WITH_ORGANIZATION,
  Visibility.SHARED_WITH_TEAM,
  Visibility.PRIVATE,
];
const OTHER_VISIBILITIES = [Visibility.PRIVATE];

const useVisibilityOptions = (
  role: RoleEnum
): { label: string; value: PinnedFieldsVisibility }[] => {
  const intl = useIntl();
  return useMemo(() => {
    const allowedVisibilities = role === RoleEnum.OWNER ? ALL_VISIBILITIES : OTHER_VISIBILITIES;
    return ALL_VISIBILITIES.map((visibility) => ({
      disabled: !allowedVisibilities.includes(visibility),
      label: getVisibilityDisplayName(intl, visibility, role),
      value: visibility,
    }));
  }, [intl, role]);
};

export default useVisibilityOptions;
